<template>
    <div class="system-message">
        <table class="result-table">
            <tr v-for="(result, index) in message.data.data" :key="result.player_name">
                <td>{{ index + 1 }}.</td>
                <td>
                        <span :style="{'color': result.color}">
                            {{ result.player_name }}
                        </span>
                </td>
                <td>{{ result.points }} {{ getPointsText(result.points) }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: Object,
            required: true
        },
    },

    methods: {
        /**
         * Очки
         */
        getPointsText(points) {
            return  this.$tc('message.point', points);
        },
    }
}
</script>

<style scoped>

</style>
